import * as React from "react";
import { cx } from "utils/join-classnames";
import { IconNames } from "core/models";
import { Icon, Tooltip } from "ui/components";
import styles from "./FragmentCard.module.scss";

interface Props {
    title: string;
    onClick(): void;
    icon: IconNames;
    disabled?: boolean;
    disabledText?: string;
    tooltip?: string;
    sharedOnSocial?: boolean;
}
const OptionsPopoverItem: React.FC<Props> = ({
    disabled,
    onClick,
    title,
    disabledText,
    icon,
    tooltip,
    sharedOnSocial,
}: Props) => (
    <Tooltip text={tooltip || ""} disabled={!tooltip}>
        <button
            className={cx(
                styles.options__item,
                disabled ? styles.option__item__disabled : null,
            )}
            disabled={disabled}
            onClick={onClick}
            type="button"
        >
            <div className={styles.options__icon}>
                <Icon className={styles.socials__icon} name={icon} />
                {sharedOnSocial && (
                    <div className={styles.sharing_success}>
                        <Tooltip text={`Shared on ${title}`}>
                            <Icon
                                className={styles.sharing_success__icon}
                                name="check-circle"
                            />
                        </Tooltip>
                    </div>
                )}
            </div>
            <div className={styles.options_label}>
                {title}
                {disabled && disabledText && (
                    <>
                        <br />
                        <span className={styles.options__disabled__text}>
                            {disabledText}
                        </span>
                    </>
                )}
            </div>
        </button>
    </Tooltip>
);

export default OptionsPopoverItem;
